function onScroll () {
    const navbar = document.querySelector("#navigation");
    const navbarHeight = 100;
    const distanceFromTop = Math.abs(
      document.body.getBoundingClientRect().top
    );
    if (distanceFromTop >= navbarHeight) {
        if (!document.querySelector("#navigation.fixed-top")) {
            const navClone = navbar.cloneNode(true);
            document.body.appendChild(navClone);
            navClone.classList.add("fixed-top");
        }
    } else { 
        if (document.querySelector("#navigation.fixed-top")) {
            const navClone = document.querySelector("#navigation.fixed-top");
            document.body.removeChild(navClone)
        }
    }
}

document.addEventListener("scroll", function () {
    onScroll();
});

onScroll();

